import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Grid, Box, Typography, Button, CircularProgress, MenuItem, TextField
} from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useGetAllPlansQuery, usePartnerPlanIdQuery, useAssignPlanMutation } from 'services/partner-plan-service';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const PartnerStandardPlan = ({ open, onClose, userId }) => {
  const navigate = useNavigate();

  const { data: partnerPlans, isLoading } = useGetAllPlansQuery(undefined, {
    skip: !open,
  });
  const { data: currentPartnerPlan } = usePartnerPlanIdQuery(
    { partnerId: userId },
    {
      skip: !open,
    }
  );


  const [assignPlan, { isLoading: isSubmitting }] = useAssignPlanMutation();

  const validationSchema = Yup.object().shape({
    selectedPlan: Yup.string().required('Please select a plan'),
  });

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      const planId = values.selectedPlan;
      const { message } = await assignPlan({ partnerId: userId, planId }).unwrap();
      toast.success(message || 'Plan assigned successfully');
      onClose();
      navigate(0);
    } catch (error) {
      toast.error(error.message || 'Failed to assign plan');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Partner Plan</DialogTitle>

      {isLoading ? (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {currentPartnerPlan?.partnerPlan?.planName ? (
            <Box sx={{ p: 2, textAlign: 'center' }}>
              Current Plan: <Typography component="span" variant="body2" sx={{ fontSize: "16px", fontWeight: "500" }}>
                {currentPartnerPlan?.partnerPlan?.planName || 'Plan Not Found'}
              </Typography>
            </Box>
          ) : (
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="h6">Select a Plan to Assign</Typography>
            </Box>
          )}

          <Formik
            initialValues={{ selectedPlan: currentPartnerPlan?.partnerPlan?._id ? currentPartnerPlan?.partnerPlan?._id : '' }}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
          >
            {({ errors, touched, handleChange, values }) => (
              <Form>
                <DialogContent dividers>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        select
                        name="selectedPlan"
                        label="Select Plan"
                        value={values.selectedPlan}
                        onChange={handleChange}
                        fullWidth
                        error={touched.selectedPlan && Boolean(errors.selectedPlan)}
                        helperText={touched.selectedPlan && errors.selectedPlan}
                      >
                        {partnerPlans?.whitelabelPartnerPlan?.length > 0 ? (
                          partnerPlans.whitelabelPartnerPlan.map((plan) => (
                            <MenuItem key={plan._id} value={plan._id}>
                              {plan.planName}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value="" disabled>
                            {isLoading ? "Loading plans..." : "No plans available"}
                          </MenuItem>
                        )}
                      </TextField>

                    </Grid>
                  </Grid>
                </DialogContent>

                <DialogActions>
                  <Button onClick={onClose}>Cancel</Button>
                  <Button type="submit" variant="contained" disabled={isSubmitting}>
                    {isSubmitting ? 'Updating...' : 'Update Partner Plan'}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </>
      )}
    </Dialog>
  );
};

export default PartnerStandardPlan;
